export const DEFAULT_TRIAL_LENGTH_DAYS = 7;
